import { useMutation, useQueryClient } from '@tanstack/react-query';

import { customAxios } from 'lib/axios';
import { CustomField } from 'types';

type CreateCustomFieldData = {
  name: string;
  type: CustomField['type'];
  project?: string;
  org: string;
  description?: string;
  required?: boolean;
  options?: string[];
  defaultValue?: unknown;
};

const createCustomField = async (fieldData: CreateCustomFieldData): Promise<CustomField> => {
  const { data } = await customAxios.post<CustomField>('/custom-fields', fieldData);
  return data;
};

export const useCreateCustomField = (orgId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createCustomField,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['custom-fields', orgId] }).catch(() => undefined);
    },
  });
};
